import {z} from 'zod';

export const usageSchema = z.object({
  inputTokens: z.number(),
  outputTokens: z.number(),
  totalTokens: z.number(),
  model: z.string(),
});

export type Usage = z.infer<typeof usageSchema>;
